import { Helmet } from "react-helmet-async";
import Seo from "@/components/Seo";
import { Link } from "react-router-dom";

export default function AboutPage() {
    return (
        <div className="page-fade pt-32 md:pt-40 pb-24">
            <Seo
                title="About Aqualyx New Zealand — Certified Provider Network"
                description="The Aqualyx Certified Clinic network in New Zealand. Medsafe registered Class III medical device. Original injectable fat reduction backed by 15+ years of clinical heritage and 4 million vials administered worldwide."
                path="/about"
                breadcrumbs={[
                    { name: "Home", path: "/" },
                    { name: "About", path: "/about" },
                ]}
                schema={{
                    "@context": "https://schema.org",
                    "@type": "AboutPage",
                    "name": "About Aqualyx New Zealand",
                    "description": "Official New Zealand consumer destination for the original Aqualyx injectable fat reduction treatment.",
                    "mainEntity": {
                        "@type": "Organization",
                        "name": "Aqualyx New Zealand",
                        "url": "https://aqualyxnz.co.nz/",
                        "areaServed": { "@type": "Country", "name": "New Zealand" }
                    }
                }}
            />
            <Helmet>
                <meta name="keywords" content="About Aqualyx NZ, Medsafe registered fat reduction, Aqualyx certified clinic New Zealand, original Aqualyx Italy, Pasquale Motolese, Class III medical device" />
            </Helmet>
            <section className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
                    <div className="lg:col-span-7 space-y-6">
                        <div className="eyebrow">About</div>
                        <h1 className="editorial-headline text-6xl md:text-8xl">
                            A trusted<br />New Zealand<br /><span className="italic text-champagne">presence.</span>
                        </h1>
                    </div>
                    <div className="lg:col-span-5 flex items-end">
                        <p className="text-ink/70 leading-relaxed">
                            Aqualyx New Zealand is the official consumer destination for the original injectable fat reduction treatment, connecting patients with verified Aqualyx Certified Clinics across the country.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-champagne/30 border border-champagne/30">
                    {[
                        { t: "Official Presence", b: "We are the verified directory for Aqualyx in New Zealand, ensuring patients can identify certified providers from imitators." },
                        { t: "Medsafe Registered", b: "Aqualyx™ is a Class III medical device, Medsafe registered in New Zealand. Authenticity is verified through digitally numbered holograms on each vial." },
                        { t: "Patient-First Philosophy", b: "Every Aqualyx Certified Clinic operates under a patient-safety-first philosophy, including thorough consultations and progressive protocols." },
                        { t: "Professional Training", b: "All certified providers complete dedicated Aqualyx training to ensure precise, consistent, and safe delivery." },
                        { t: "Highest Safety Standards", b: "Aqualyx has 15+ years of clinical experience and over 4 million vials administered worldwide. NZ providers follow international best practice." },
                        { t: "Certified Only", b: "Beware of imitations. The original Aqualyx is available only through officially certified Aqualyx clinics in New Zealand." },
                    ].map((c, i) => (
                        <div key={i} className="bg-bone p-10 space-y-4">
                            <div className="number-stroke text-5xl">{String(i + 1).padStart(2, "0")}</div>
                            <h3 className="font-serif text-2xl leading-tight">{c.t}</h3>
                            <p className="text-sm text-ink/60 leading-relaxed">{c.b}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-20 p-12 bg-ink text-bone text-center">
                    <div className="eyebrow text-champagne mb-4">Mandatory Statement</div>
                    <p className="font-serif italic text-2xl md:text-3xl max-w-3xl mx-auto leading-snug">
                        Aqualyx™ injection non-surgically reduces localized fat deposits. Aqualyx™ is a Class III medical device. Aqualyx™ has risks and benefits. Consult your healthcare professional to determine if Aqualyx™ is right for you. Medsafe registered in New Zealand.
                    </p>
                </div>

                <div className="text-center mt-16">
                    <Link to="/clinics" className="btn-primary">Find a Certified Clinic</Link>
                </div>
            </section>
        </div>
    );
}
